import { render, staticRenderFns } from "./Caixa.vue?vue&type=template&id=7c81c747&scoped=true"
import script from "./Caixa.vue?vue&type=script&lang=js"
export * from "./Caixa.vue?vue&type=script&lang=js"
import style0 from "./Caixa.vue?vue&type=style&index=0&id=7c81c747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81c747",
  null
  
)

export default component.exports